import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { Person } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class PersonService extends ApiService {

  get(id: string) {
    return this.http.get(`${this.persionBaseURL}/api/persons/${id}`);
  }

  getUserPerson() {
    return this.http.get(`${this.persionBaseURL}/api/persons/user/person`);
  }

  create(person: Person) {
    return this.http.post(`${this.persionBaseURL}/api/persons/createPersonForCurrentUser`, person);
  }

  update(id, person: Person) {
    return this.http.put(`${this.persionBaseURL}/api/persons/${id}`, person);
  }
  verifyByESI(id, person: any) {
    return this.http.post(`${this.persionBaseURL}/api/persons/${id}/VerifyPersonByESI`, person);
  }
}
